import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Projects", path: "/projects" },
    { name: "Blog", path: "/blog" },
    { name: "Contact", path: "/contact" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActiveRoute = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <div className="fixed top-6 left-0 w-full flex justify-center z-50 px-4">
      <nav
        className={`
          w-full max-w-7xl
          transition-all duration-300
          border border-slate-200
          rounded-2xl
          ${
            scrolled
              ? "bg-white/95 backdrop-blur-xl shadow-lg shadow-blue-500/5"
              : "bg-white/80 backdrop-blur-md"
          }
        `}
      >
        <div className="flex justify-between items-center px-8 py-4">

          {/* Logo */}
          <Link
            to="/"
            className="text-xl md:text-2xl font-semibold tracking-tight text-slate-900"
          >
            Peter <span className="text-blue-600">Magaga</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">

            {navLinks.map((link) => {
              const isActive = isActiveRoute(link.path);

              return (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`
                    relative text-sm font-medium transition duration-300
                    ${
                      isActive
                        ? "text-blue-600"
                        : "text-slate-600 hover:text-blue-600"
                    }
                  `}
                >
                  {link.name}

                  {/* Animated underline */}
                  <span
                    className={`
                      absolute -bottom-2 left-0 h-[2px] rounded-full
                      bg-blue-600 transition-all duration-300
                      ${
                        isActive
                          ? "w-full"
                          : "w-0 group-hover:w-full"
                      }
                    `}
                  />
                </Link>
              );
            })}

            {/* Primary CTA */}
            <Link
              to="/contact"
              className="
                bg-blue-600 hover:bg-blue-700
                text-white
                px-6 py-2.5
                rounded-full
                text-sm font-medium
                transition duration-300
                hover:-translate-y-0.5
                hover:shadow-lg
                hover:shadow-blue-500/20
              "
            >
              Hire Me
            </Link>

          </div>

          {/* Mobile Toggle */}
          <button
            className="md:hidden text-slate-700 transition"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`
            md:hidden overflow-hidden transition-all duration-300
            ${isOpen ? "max-h-96 py-6 px-8" : "max-h-0"}
          `}
        >
          <div className="space-y-6">

            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="block text-slate-600 hover:text-blue-600 transition duration-300"
              >
                {link.name}
              </Link>
            ))}

            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              className="
                block text-center
                bg-blue-600 hover:bg-blue-700
                px-6 py-3
                rounded-full
                text-white font-medium
                transition duration-300
              "
            >
              Hire Me
            </Link>

          </div>
        </div>

      </nav>
    </div>
  );
}